import { lazy } from 'react';

export const EnrollmentsPage = lazy(() => import('./EnrollmentsPage'));
